import { Component, OnInit, ElementRef, ViewChild, forwardRef, Input, SimpleChanges, OnChanges, HostListener, HostBinding, Output, EventEmitter, Inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { isNil, set } from 'lodash-es';
import { Styles } from './models/style';
import { SelectorComponent } from './components/selector.component';
import { ESelectorType } from './components/selector.component';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Manufacturing_ShellService } from './Manufacturing.shell.service';
import { Manufacturing_OperationService } from './Manufacturing.operation.service';
import { Manufacturing_DatasourceService } from './Manufacturing.datasource.index';
import { Manufacturing_FlowService } from './Manufacturing.flow.index';
import { Manufacturing_ReportService } from './Manufacturing.report.index';
import { Manufacturing_LocalizationService } from './Manufacturing.localization.service';
import { Manufacturing_material_substitutions_dd_ComponentContextService } from './Manufacturing.material_substitutions_dd.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Manufacturing.frontend.types'
import { $frontendTypes as $types} from './Manufacturing.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';

@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Manufacturing-material_substitutions_dd_multi',
  templateUrl: './Manufacturing.material_substitutions_dd_multi.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Manufacturing_material_substitutions_dd_multiComponent),
      multi: true
    }
  ]
})
export class Manufacturing_material_substitutions_dd_multiComponent extends BaseComponent implements OnInit, ControlValueAccessor, OnChanges {

  @Input() type?: ESelectorType;
  _disabled = false;
  @Input() get disabled() { 
      return this._disabled 
      ; }
  set disabled(val: any) { this._disabled = val; }

  @Input() placeholder = '';
  @Input() styles: Styles;
  @Input() tooltip = '';

  @Output() displayTextChange: EventEmitter<string> = new EventEmitter();

  @ViewChild(SelectorComponent) selector: SelectorComponent;

  @HostBinding('tabIndex') get tabIndex() { return -1; }
  @HostListener('focus')
  focus() {
    this.selector?.focus();
  }

  get isMulti() {
    return true;
  }

  get isSingle() {
    return false;
  }


  inParams: { material_ids?: number[], package_id?: number, warehouse_id?: number, substitution_ids?: number[], needed_amount?: number } = { material_ids: [], package_id: null, warehouse_id: null, substitution_ids: [], needed_amount: null };
  @Input('material_ids') set $inParams_material_ids(value: any) {
    this.inParams['material_ids'] = value;
  }
  get $inParams_material_ids(): any {
    return this.inParams['material_ids'] ;
  }
  @Input('package_id') set $inParams_package_id(value: any) {
    this.inParams['package_id'] = value;
  }
  get $inParams_package_id(): any {
    return this.inParams['package_id'] ;
  }
  @Input('warehouse_id') set $inParams_warehouse_id(value: any) {
    this.inParams['warehouse_id'] = value;
  }
  get $inParams_warehouse_id(): any {
    return this.inParams['warehouse_id'] ;
  }
  @Input('substitution_ids') set $inParams_substitution_ids(value: any) {
    this.inParams['substitution_ids'] = value;
  }
  get $inParams_substitution_ids(): any {
    return this.inParams['substitution_ids'] ;
  }
  @Input('needed_amount') set $inParams_needed_amount(value: any) {
    this.inParams['needed_amount'] = value;
  }
  get $inParams_needed_amount(): any {
    return this.inParams['needed_amount'] ;
  }

  fullTextSearch: string;

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Manufacturing_ShellService,
    private $datasources: Manufacturing_DatasourceService,
    private $flows: Manufacturing_FlowService,
    private $reports: Manufacturing_ReportService,
    private $localization: Manufacturing_LocalizationService,
    private $operations: Manufacturing_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Manufacturing_material_substitutions_dd_ComponentContextService,
    private _elementRef: ElementRef
    ) {
      super();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  async $init() {
    this.selector?.init();
  }

  onKeyDown($event: KeyboardEvent) {
    //TODO:KeyDown    
  }

  //ControlValueAccessor
  _innerValue: any;

  onChange: any = () => { };
  onTouch: any = () => { };

  get value(): number | number[] {
    return this._innerValue;
  }

  set value(val:  number | number[]) {
    if (this._innerValue !== val) {
      this._innerValue = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  writeValue(value: any): void {
    this._innerValue = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  displayWithFn(value: any): Promise<{displayText:string, selected :Array<{ key: any; name: string; disabled?: boolean; selected?: boolean;}>}> {
    const promise = new Promise<{displayText:string, selected :Array<{ key: any; name: string; disabled?: boolean; selected?: boolean;}>}>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = null;
      const $fullTextSearch = null;
      this.$datasources.Manufacturing.ds_get_material_substitutions.getByKeys({
        $keys: value,
        material_ids:  $selector.inParams.material_ids ,
        package_id:  $selector.inParams.package_id ,
        warehouse_id:  $selector.inParams.warehouse_id ,
        substitution_ids:  $selector.inParams.substitution_ids ,
      }).then(result => {
        const selected = value.map(k => {
          const found = result.result
            .find(i => i.Id === k);
          const e: { Id?: number, MaterialId?: number, PackagingId?: number, Ratio?: number, SubstitutionMaterialId?: number, SubstitutionPackagingId?: number, SubstitutionMaterialPackagingLookup?: { PackagingId?: number, BasePackagingQuantity?: number, Material?: { Id?: number, Name?: string, InventoryByWarehouseMaterial?: { WarehouseId?: number, MaterialId?: number, PackagedId?: number, CurrentlyAvailableAmount?: number, CurrentlyAvailablePackagedAmount?: number }[] }, Packaging?: { Name?: string, ShortName?: string } } } = found 
            ?? { 
              Id : k
            };

          const $option = { entity: e };
          const $entity = e;
          const $resultOption = { key: null, name: found ? `${$option.entity.Ratio * $selector.inParams.needed_amount} ${$option.entity.SubstitutionMaterialPackagingLookup?.Packaging?.ShortName ?? ""} of ${$option.entity.SubstitutionMaterialPackagingLookup?.Material?.Name ?? ""} at a ratio of 1:${$option.entity.Ratio}` : 'No data to display', disabled: false, selected:true };
          $resultOption.key = $option.entity.Id;
          return $resultOption;
        });
        const displayText = value.map(k => {
          const found = result.result
            .find(i => i.Id === k);
          if (found) {
            const $option = { entity: found };
            const $entity = found;
            return `${$option.entity.Ratio * $selector.inParams.needed_amount} ${$option.entity.SubstitutionMaterialPackagingLookup?.Packaging?.ShortName ?? ""} of ${$option.entity.SubstitutionMaterialPackagingLookup?.Material?.Name ?? ""} at a ratio of 1:${$option.entity.Ratio}`;
          } else {
            return 'No data to display';
          }
        })
        .join(
           ', '
        );
        this.displayTextChange.emit(displayText);
        resolve({displayText, selected});
      });
    });
    return promise;
  }

  optionsFn(filterText: string): Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }> {

    const promise = new Promise<{ list: Array<{ key: any; name: string; disabled?: boolean; }>, totalCount?: number, top?: number }>((resolve, reject) => {

      const $selector = this;
      const $utils = this.$utils;

      this.fullTextSearch = filterText;
      const $fullTextSearch = filterText;
      this.$datasources.Manufacturing.ds_get_material_substitutions.getList({
        $top: 25,
        $skip: 0,
        material_ids:  $selector.inParams.material_ids ,
        package_id:  $selector.inParams.package_id ,
        warehouse_id:  $selector.inParams.warehouse_id ,
        substitution_ids:  $selector.inParams.substitution_ids ,
      }).then(result => {
        resolve({
          list: result.result.map(item => {
            const $option = { entity: item };
            const $entity = item;
            const $resultOption = { key: null, name: `${$option.entity.Ratio * $selector.inParams.needed_amount} ${$option.entity.SubstitutionMaterialPackagingLookup?.Packaging?.ShortName ?? ""} of ${$option.entity.SubstitutionMaterialPackagingLookup?.Material?.Name ?? ""} at a ratio of 1:${$option.entity.Ratio}`, disabled: null };
            $resultOption.key = $option.entity.Id;
            return $resultOption;
          }),
          totalCount: result.totalCount,
          top: 25
        });
      });

    });

    return promise;

  }

}
